var NOOP = function () {
    //  NOOP
};

export default NOOP;